/*
 * @Author: cxd
 * @Date: 2023-05-16 10:29:21
 * @LastEditors: cxd
 * @FilePath: /src/api/index.js
 * @Description: api接口管理
 */

import app from './app'
import chat from './chat'
import mine from './mine'
const api = {
    ...app,
    ...chat,
    ...mine
}
export default api;
